import { GET_DOCTOR_SCHEDULE } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

export interface RequestResponse {
    success: boolean;
    data: Data;
}
export interface Data {
    // services: Services;
    schedule: Schedule;
    updatedAt: string;
    // meta: Meta;
}

export interface Schedule {
    [cId: string]: {
        [day: number]: {
            bounds: {
                e: number;
                s: number;
            }[];
        };
    };
}

export default ({ docId }: { docId: string }): Promise<RequestResponse> => {
    return fetchWithRefresh(GET_DOCTOR_SCHEDULE(docId), {
        method: 'GET',
        headers: {
            'Content-type': 'application/json',
        },
    }).then((res) => {
        return res.json();
    });
};
